module.exports = __webpack_public_path__ + "img/step4.3a2dc727.png";